// src/components/AVVProcess/ImageScoreTable.jsx
import React from "react";
import { Table, Typography } from "antd";

import UPDATES_RECEIVED from "./data.json";
import CustomCard from "../../blocks/Card/Card";
import { DemoImage } from "./DemoImage";
const images = UPDATES_RECEIVED[0].images;

const { Title } = Typography;

const ImageScoreTable = () => {
  const columns = [
    {
      title: "Image",
      dataIndex: "url",
      render: (url) => (
        <DemoImage src={url} alt="House" style={{ width: 100, height: 75 }} />
      ),
    },
    {
      title: "Room Type",
      dataIndex: "models",
      render: (models) => models.room_classification.results[0]?.class || "N/A",
    },
    {
      title: "Quality Score",
      dataIndex: "models",
      render: (models) => models.quality_score.results[0]?.score.toFixed(2),
    },
    {
      title: "Condition Score",
      dataIndex: "models",
      render: (models) => models.condition_score.results[0]?.score.toFixed(2),
    },
  ];

  return (
    <CustomCard title={<Title level={4}>Image Scores</Title>}>
      <Table
        columns={columns}
        dataSource={images}
        rowKey="_id"
        pagination={false}
      />
    </CustomCard>
  );
};

export default ImageScoreTable;
